function Privacy() {
  return (
    <div className="privacy">
      <div className="privacy-container">
        <div className="page-header">
          <h1>プライバシーポリシー - Privacy Policy</h1>
          <p>最終更新日: 2026年01月21日</p>
        </div>

        <div className="privacy-content">
          <section>
            <p>
              OratyLabo(旧:ゆーたの開発ラボ) （以下「当グループ」とします。）は、Discord及びサイト上で提供するサービス（以下「本サービス」とします。）
              におけるユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」とします。）を定めます。
              </p>
          </section>
          <section>
            <h2>第1条 (基本方針)</h2>
            <p>
              当グループでは、利用者のプライバシーを尊重し、
              個人情報の保護に努めています。
            </p>
          </section>
          <section>
            <h2>第2条 (個人情報の収集方法)</h2>
            <p>
              当グループは、お問い合わせなどの際にユーザー名・メールアドレス等の個人情報をお尋ねすることがあります。
              また、本サービスにてゲームにおいてユーザーを識別する情報（以下、個人情報に含めるものとします。）をデーターベース上に保存する事があります。
            </p>
          </section>
          <section>
            <h2>第3条 (個人情報の収集・利用目的)</h2>
            <p>
              当グループが個人情報を収集・利用する目的は、以下のとおりです。
            </p>
            <ul>
              <li>本サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li>有料サービスにおいて，ユーザーに利用料金を請求するため</li>
              <li>上記の利用目的に付随する目的</li>
            </ul>
            <p>
              取得した個人情報は、上記の目的のみに利用させていただくもので、これらの目的以外では利用いたしません。
            </p>
          </section>
          <section>
            <h2>第4条 (利用目的の変更)</h2>
            <p>当グループは、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。
              利用目的の変更を行った場合には、変更後の目的について、当グループ所定の方法によりユーザーに通知し、または本サイト上に公表するものとします。
            </p>
          </section>
          <section>
            <h2>第5条 (個人情報の第三者開示について)</h2>
            <p>
              取得した個人情報は適切に管理し、以下に該当する場合を除いて第三者に開示することはありません。
            </p>
            <ul>
              <li>法令に基づく場合</li>
              <li>法令により開示が求められた場合</li>
            </ul>
          </section>
          <section>
            <h2>第6条 (その他自動的に収集される情報)</h2>
            <p>
              当グループが運営するサービス・サイトの一部において、下記の情報を自動的に収集される場合があります。
              これらの情報は、個人を特定できない形で収集・利用され、統計的な分析やサービス改善のために使用されます。
            </p>
            <ul>
              <li>アクセスログ（IPアドレス、ブラウザ情報、アクセス日時等）</li>
              <li>Cookieおよび類似技術による情報</li>
              <li>サイト利用状況（ページビュー、クリック等）</li>
              <li>コマンド利用状況（使用されたコマンド名）</li>
            </ul>
          </section>
          <section>
            <h2>第7条 (Cookieの使用について)</h2>
            <p>当サイトでは以下の目的でCookieを使用します。</p>
            <ul>
              <li>サイトの機能改善とパフォーマンス測定</li>
              <li>利用者の行動分析とコンテンツ最適化</li>
              <li>広告のパーソナライゼーション</li>
            </ul>
            <p>
              当グループが運営するサイトでは、一部において広告配信やアクセス解析のためにCookieを使用しています。
              Cookieによりご利用のブラウザを識別していますが、特定の個人の識別はできない状態で匿名性が保たれています。
              Cookieの使用を望まない場合、ブラウザからCookieを無効に設定できます。
            </p>
          </section>

          <section>
            <h2>第8条 (広告配信サービスについて)</h2>
            <h3>1. 広告配信サービスの利用</h3>
            <p>
              当グループが運営するサイトの一部において、第三者の広告配信サービスを利用して広告を掲載しています。
              第三者の広告配信サービス提供事業者は、ユーザーの興味に応じたパーソナライズ広告を表示するためにCookieを使用しています。
              Googleアドセンスに関する詳細は<a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener">「広告 – ポリシーと規約 – Google」</a>をご確認ください。
            </p>
            
            <h3>2. 広告のカスタマイズ</h3>
            <p>
              Googleの広告設定でパーソナライズ広告を無効にできます。<br/>
              <a href="https://adssettings.google.com/" target="_blank" rel="noopener">広告設定ページ</a>
            </p>
          </section>

          <section>
            <h2>第9条 (アクセス解析ツールについて)</h2>
            <p>
              当グループが運営するサイトの一部において、「Googleアナリティクス」によってアクセス情報を解析しています。
              Googleアナリティクスはトラフィックデータの収集のためにCookieを使用していますが、アクセス情報の収集はCookieを無効にすることで拒否できます。
              Google社のデータ収集・処理の仕組みについては、『<a href="https://policies.google.com/technologies/partner-sites?hl=ja" target="_blank" rel="noopener">Google のサービスを使用するサイトやアプリから収集した情報の Google による使用</a>』をご覧ください。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。
              この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
            </p>
          </section>
          <section>
            <h2>第10条 (セキュリティ)</h2>
            <p>
              当グループが運営するサイトでは、情報の保護のために適切な技術的・管理的セキュリティ対策に努めています。
            </p>
            <ul>
              <li>SSL/TLS暗号化通信</li>
              <li>CloudflareによるDDoS保護</li>
            </ul>
          </section>
          <section>
            <h2>第11条 (プライバシーポリシーの変更)</h2>
            <p>
              1. 本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく変更することができるものとします。<br/>
              2. 当グループが別途定める場合を除いて、変更後のプライバシーポリシーは、本サイトに掲載したときから効力を生じるものとします。
            </p>
          </section>
          <section>
            <h2>第12条 (お問い合わせ)</h2>
            <p>
              本ポリシーに関するご質問・ご意見は、
              <a href="https://discord.gg/k5Feum44gE" target="_blank" rel="noopener">
                Discordサポートサーバー
              </a>
              までお寄せください。
            </p>
          </section>
          <p>以上</p>
        </div>
        <div className="privacy-footer">
            <p>制定日: 2023年04月04日</p>
            <p>改定日: 2026年01月21日</p>
            <p>OratyLabo (旧:ゆーたの開発ラボ)</p>
          </div>
      </div>
    </div>
  )
}

export default Privacy